//= require active_admin/base
//= require activeadmin_addons/all
//= require admin/global_search/handler
//= require admin/bulk_in_app_notifications/handler

$(document).ready(function() {
  // Color picker functionality
  $('.color-picker').each(function() {
    let $input = $(this);

    let $colorPreview = $('<div class="color-picker-preview"></div>');
    $input.after($colorPreview);

    function updatePreview() {
      let color = $input.val() || '#FFFFFF';
      $colorPreview.css('background-color', color);
    }

    updatePreview();

    $input.on('input', updatePreview);

    $colorPreview.on('click', function() {
      let colorPicker = document.createElement('input');
      colorPicker.type = 'color';
      colorPicker.value = $input.val() || '#FFFFFF';

      $(colorPicker).on('input', function() {
        $input.val(this.value);
        updatePreview();
      });

      colorPicker.click();
    });
  });

  // Company select fields mutual blocking functionality
  function updateCompanySelectFields() {
    let allowedCompanyIds = $('#allowed_company_ids');
    let excludedCompanyIds = $('#excluded_company_ids');

    if (allowedCompanyIds.length > 0 && excludedCompanyIds.length > 0) {
      // Check if allowed_company_ids has any selected values
      if (allowedCompanyIds.val() && allowedCompanyIds.val().length > 0) {
        // Disable excluded_company_ids
        excludedCompanyIds.prop('disabled', true);
        // Add a visual indication that it's disabled
        excludedCompanyIds.closest('.input').addClass('disabled');
      } else {
        // Enable excluded_company_ids
        excludedCompanyIds.prop('disabled', false);
        excludedCompanyIds.closest('.input').removeClass('disabled');
      }

      // Check if excluded_company_ids has any selected values
      if (excludedCompanyIds.val() && excludedCompanyIds.val().length > 0) {
        // Disable allowed_company_ids
        allowedCompanyIds.prop('disabled', true);
        // Add a visual indication that it's disabled
        allowedCompanyIds.closest('.input').addClass('disabled');
      } else {
        // Enable allowed_company_ids
        allowedCompanyIds.prop('disabled', false);
        allowedCompanyIds.closest('.input').removeClass('disabled');
      }
    }
  }

  // Run on page load
  updateCompanySelectFields();

  // Add event listeners for changes
  $('#allowed_company_ids, #excluded_company_ids').on('change', function() {
    updateCompanySelectFields();
  });
});
document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("protection-step-modal");
    const button = document.getElementById("edit-protection-step-button");
    const close = document.getElementById("close-protection-modal");

    if (button && modal) {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            modal.style.display = "block";
        });
    }

    if (close && modal) {
        close.addEventListener("click", () => {
            modal.style.display = "none";
        });
    }

    document.querySelectorAll('[data-dismiss="modal"]').forEach((el) =>
        el.addEventListener("click", () => {
            modal.style.display = "none";
        })
    );
});

